import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import ViewBase from "../../../../framework/core/mvvm/view_base";
import ScratchTicketCom from "./scratch_ticket_com";


const { ccclass, property } = cc._decorator;


@ccclass
@moduleInit("Toast")
export default class ScratchTicketView extends ViewBase {

    @property(ScratchTicketCom)
    tickets: ScratchTicketCom[] = [];

    @property(cc.Node)
    infoNodes : cc.Node[] = [];
    
    private curShowTicketCount = 0;


    start(){


    }

    onShow(intentData? : any){

        let reset = intentData.reset;

        this.curShowTicketCount = 0;
        this.tickets.forEach(ticket => {

            if (reset) {
                ticket.reset();                    
            }

            ticket.showAllCallback = this.onShowTicket;
            
            if(ticket.showAll){
                this.curShowTicketCount++;
            }

        });
    }

    private onShowTicket(){

        this.curShowTicketCount++;
    }
    
    /**
     * 兑奖
     */
    @bindButtonClickEvent("exchange_btn")
    onExchangeBtn(){

        console.log(" onExchangeBtn " , this.curShowTicketCount);

        if (this.curShowTicketCount < 7) {            
            return;
        }
        
    }


}